<template>
  <div class="image-view-container"
    :class="[imageClass, customClass]"
    :style="getImageaspectRatio()">
    <div class="image-wrapper">
      <img
        v-if="imageSource"
        :src="imageSource" />
      <div class="empty-container" v-if="!imageSource">
        <div class="detail">{{emptyMessageText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    source: {
      type: [Object, String, Array],
    },
    defaultSource: {
      type: Object,
      default: () => {},
    },
    aspectRatio: {
      type: String,
      default: 'original', // 16:9, 9:16, 4:3, 2:1, 1.91:1, 1:1, original
    },
    imageSize: {
      type: String,
      default: 'cover320w180h',
    },
    emptyMessageText: {
      type: String,
      default: 'ยังไม่มีรูปปก',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageSource() {
      if (this.source) {
        if (typeof this.source === 'string') {
          return this.source;
        }

        if (typeof this.source === 'object') {
          if (this.source.type === 'thumbor') {
            if (this.imageSize === 'original') {
              return this.generateOriginalSource(this.source.baseUrl);
            }
            return _.get(this.source.urls, this.imageSize, null);
          }
          if (this.source.type === 'thaipbsProgram') {
            return _.get(this.source.urls, this.imageSize, null);
          }
          if (_.isEmpty(this.source)) {
            return this.defaultSource;
          }
          return _.get(this.source.urls, this.imageSize, null);
        }
      }

      if (this.defaultSource) {
        return this.defaultSource;
      }
      return null;
    },
    imageClass() {
      let customClass = '';

      if (!this.imageSource) {
        customClass = `${customClass} image-empty`;
      }

      if (this.isOriginalSize()) {
        customClass = `${customClass} image-original`;
      }

      return customClass;
    },
  },
  methods: {
    generateOriginalSource(mediaBaseUrl) {
      const idx = mediaBaseUrl.indexOf('/images');
      return `//${mediaBaseUrl.slice(0, idx + 7)}/original${mediaBaseUrl.slice(idx + 7, mediaBaseUrl.length)}`;
    },
    isOriginalSize() {
      return this.aspectRatio && this.aspectRatio === 'original';
    },
    getImageaspectRatio() {
      if (this.aspectRatio && this.aspectRatio !== 'original') {
        const aspectRatio = this.aspectRatio.split(/[:]/);
        if (aspectRatio[0] && aspectRatio[1]) {
          const width = parseInt(aspectRatio[0], 10);
          const height = parseInt(aspectRatio[1], 10);
          return {
            paddingTop: `${(height / width) * 100}%`,
          };
        }
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.image-view-container {
  width: 100%;
  position: relative;
  overflow: hidden;

  &:not(.image-original) , &.image-empty.image-original {
    padding-top: 56.25%;

    .image-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img {
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }

  &.image-original {
    img {
      width: 100%;
    }
  }
}

.image-empty {
  background-color: $gray-700;
  position: relative;

  .empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: $gray-400;

    text-align: center;

    font-size: $font-size-sm;
    font-family: $font-family-base;
  }
}

</style>
